var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flamingo",class:{ 'is-hidden': _vm.shouldHideFlamingo }},[_c('span',[_c('figure',{style:(_vm.flamingoBackgroundStyle())})])])}
var staticRenderFns = []

export { render, staticRenderFns }